<template lang="html">
  <section class="take-place column ctn-patrimonial-landscape no-edit">
		<div class="heading-sub-client row">
			<router-link :to="{name: 'Client', params: { clientId: client.id}}" class="btn-icon">
				<span class="icon-arrow-back"></span>
			</router-link>
			<div class="label">
				Les derniers échanges avec {{ client.firstname }} {{ client.lastname }}
			</div>
		</div>
		<div class=""><br /></div>
		<chat :title="'Messages'" :isAdvisor="true" :threads="threads" />
  </section>
</template>

<script>
import Chat from '@/common/components/chat'
export default {
	name: 'ChatClient',
	components: {
		Chat
	},
	data () {
		return {
			client: this.$store.getters.getClient(this.$route.params.clientId)
		}
	},
	mounted () {
		this.$store.dispatch('getMessages')
	},
	computed: {
		threads () {
			return this.$store.getters.threadOfClient(this.$route.params.clientId).reverse()
		}
	}
}
</script>

<style lang="scss" scoped>
	.heading-sub-client {
		margin-top: 2rem;
	}
</style>



// WEBPACK FOOTER //
// Chat.vue?0a3501f4